// import case names
import { get, has, map, isEmpty, forEach, isArray } from 'lodash';

// local dependencies
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';

// get a global redux store ( creates empty store if not already created )
const store = getStore();

/**
 * @type {function}
 * @desc Resolvers are pure functions used for resolving templates (React components) or to transform some data.
 * A resolver function takes an `id` and an optional `payload` and returns a `result`.
 * Based on `switch` cases inside this function, correct `result` should be returned.
 * @param {object} payload
 * @example
 * import { resolveEntityCellData } from 'resolvers/resolveEntityCellData';
 */
export const resolveEntityCellData = ( { items, component } ) => {

    // get options from app context
    const contextOptions = get( store.getState()[ REDUCER.APP_CONTEXT ], 'component.data.options', {} );
    
     // add options to items from `data`
    forEach( items, ( item = {} ) => {
        if( ! isEmpty( item.options ) ) {
            if( isArray( item.options ) ) {
                item.options = map( item.options, ( optionsSetName ) => {
                    if( has( component, `data.options.${ optionsSetName }` ) ) {
                        return get( component, `data.options.${ optionsSetName }`, [] );
                    } else if( has( contextOptions, optionsSetName ) ) {
                        return get( contextOptions, optionsSetName, [] );
                    } else {
                        return [];
                    }
                } );
            } else {
                if( has( component, `data.options.${ item.options }` ) ) {
                    item.options = get( component, `data.options.${ item.options }`, [] );
                } else if( has( contextOptions, item.options ) ) {
                    item.options = get( contextOptions, item.options, [] );
                } else {
                    item.options = [];
                }
            }
        }

    } );

    return items;

};
